export const calculateDate = (monthsAhead: number): Date => {
  const d = new Date()
  d.setMonth(d.getMonth() + monthsAhead)
  return d
}
